import jQuery from 'jquery';
import debug from 'debug';

import { TagManager } from './tag-manager';
import { Logger } from './logger';

const dstm = window.dstm || {};

const logger = (dstm.logger = new Logger({ debug: dstm.debug }));
if (dstm.debug) {
  debug.enable('TagManagerJS,TagManagerJS:*');
  logger.debug('debug enabled.');
}

TagManager.load(jQuery, () => {
  logger.debug('manager loaded.');
});
